export const categories = [
  { slug: "all", name: "全部", icon: "ri-apps-line" },
  { slug: "romance", name: "恋爱", icon: "ri-heart-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "action", name: "动作", icon: "ri-flashlight-line" },
  { slug: "thriller", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "drama", name: "剧情", icon: "ri-emotion-line" },
  { slug: "bl", name: "BL", icon: "ri-men-line" },
  { slug: "gl", name: "GL", icon: "ri-women-line" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "horror", name: "恐怖", icon: "ri-ghost-line" },
];

export const comics = [
  {
    id: 1,
    slug: "secretarys-temptation",
    title: "秘书的诱惑",
    author: "金秀雅",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20beautiful%20female%20office%20worker%20in%20elegant%20black%20suit%20standing%20by%20modern%20office%20desk%2C%20romantic%20dramatic%20lighting%2C%20soft%20watercolor%20illustration%20style%2C%20clean%20white%20background%2C%20manga%20aesthetic&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    description: "职场新人林小美意外成为公司总裁的贴身秘书，从此开启了一段充满诱惑与挑战的职场恋情。面对帅气多金的上司，她能否守住自己的心？一段甜蜜又虐心的办公室恋爱故事即将展开。",
    rating: 9.2,
    views: 1850000,
    status: "连载中",
    tags: ["办公室", "恋爱", "总裁", "职场"],
    updateDate: "2026-08-05",
    chapters: [
      { number: 1, title: "第一话 - 入职第一天", date: "2026-03-15" },
      { number: 2, title: "第二话 - 总裁的秘密", date: "2026-03-22" },
      { number: 3, title: "第三话 - 意外的拥抱", date: "2026-03-29" },
      { number: 4, title: "第四话 - 深夜加班", date: "2026-04-05" },
      { number: 5, title: "第五话 - 心跳加速", date: "2026-04-12" },
      { number: 6, title: "第六话 - 暧昧的边界", date: "2026-04-19" },
      { number: 7, title: "第七话 - 情敌出现", date: "2026-04-26" },
      { number: 8, title: "第八话 - 真心告白", date: "2026-05-03" },
      { number: 9, title: "第九话 - 甜蜜约会", date: "2026-05-10" },
      { number: 10, title: "第十话 - 危机降临", date: "2026-05-17" },
      { number: 11, title: "第十一话 - 信任考验", date: "2026-05-24" },
      { number: 12, title: "第十二话 - 和好如初", date: "2026-05-31" },
    ],
  },
  {
    id: 2,
    slug: "demon-kings-bride",
    title: "魔王的契约新娘",
    author: "李智恩",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20fantasy%20illustration%20of%20beautiful%20princess%20in%20ancient%20elegant%20gown%20standing%20before%20dark%20castle%2C%20mystical%20atmosphere%2C%20rose%20petals%20falling%2C%20clean%20soft%20watercolor%20manga%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    description: "为了拯救家族，贵族千金被迫与传说中的魔王签订婚约。她以为等待自己的是地狱，却发现这位魔王远比想象中温柔。当王国阴谋浮出水面，她必须在爱与责任之间做出选择。",
    rating: 9.5,
    views: 2560000,
    status: "连载中",
    tags: ["奇幻", "恋爱", "契约婚姻", "魔王"],
    updateDate: "2026-08-04",
    chapters: [
      { number: 1, title: "第一话 - 契约之始", date: "2026-02-20" },
      { number: 2, title: "第二话 - 魔王城堡", date: "2026-02-27" },
      { number: 3, title: "第三话 - 初雪之约", date: "2026-03-06" },
      { number: 4, title: "第四话 - 暗流涌动", date: "2026-03-13" },
      { number: 5, title: "第五话 - 真心渐露", date: "2026-03-20" },
      { number: 6, title: "第六话 - 王都阴谋", date: "2026-03-27" },
      { number: 7, title: "第七话 - 生死与共", date: "2026-04-03" },
      { number: 8, title: "第八话 - 前世今生", date: "2026-04-10" },
      { number: 9, title: "第九话 - 封印解除", date: "2026-04-17" },
      { number: 10, title: "第十话 - 最终决战", date: "2026-04-24" },
      { number: 11, title: "第十一话 - 新王加冕", date: "2026-05-01" },
      { number: 12, title: "第十二话 - 永恒誓约", date: "2026-05-08" },
    ],
  },
  {
    id: 3,
    slug: "revenge-of-the-shadow",
    title: "暗影复仇者",
    author: "朴正宇",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20action%20illustration%20of%20mysterious%20man%20in%20black%20coat%20standing%20in%20rainy%20alley%20with%20neon%20city%20lights%20background%2C%20dark%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20clean%20watercolor%20manga%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    description: "前特种兵韩志浩目睹家人被黑帮杀害后，化身为暗影复仇者。他潜入地下世界，以暴制暴，一步步摧毁庞大的犯罪帝国。但当真相逐渐浮出水面，他发现幕后黑手竟然是……",
    rating: 9.0,
    views: 1420000,
    status: "已完结",
    tags: ["动作", "复仇", "犯罪", "热血"],
    updateDate: "2026-07-20",
    chapters: [
      { number: 1, title: "第一话 - 坠落之始", date: "2025-11-10" },
      { number: 2, title: "第二话 - 地下拳场", date: "2025-11-17" },
      { number: 3, title: "第三话 - 第一个目标", date: "2025-11-24" },
      { number: 4, title: "第四话 - 意外盟友", date: "2025-12-01" },
      { number: 5, title: "第五话 - 追踪线索", date: "2025-12-08" },
      { number: 6, title: "第六话 - 黑帮老大", date: "2025-12-15" },
      { number: 7, title: "第七话 - 生死时速", date: "2025-12-22" },
      { number: 8, title: "第八话 - 真相大白", date: "2025-12-29" },
      { number: 9, title: "第九话 - 最终复仇", date: "2026-01-05" },
      { number: 10, title: "第十话 - 新的人生", date: "2026-01-12" },
    ],
  },
  {
    id: 4,
    slug: "night-school-mystery",
    title: "夜校疑云",
    author: "崔敏智",
    category: "thriller",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20mystery%20thriller%20illustration%20of%20students%20in%20dark%20school%20corridor%20at%20night%20with%20flashlight%2C%20eerie%20atmosphere%2C%20moonlight%20through%20windows%2C%20suspenseful%20watercolor%20manga%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    description: "一所普通高中在夜晚开设的补习班中，接连发生诡异事件。五名学生组成调查小组，却发现学校隐藏着一个惊人的秘密。每一间教室，每一条走廊，都可能是他们的葬身之地。",
    rating: 8.8,
    views: 980000,
    status: "连载中",
    tags: ["悬疑", "校园", "恐怖", "推理"],
    updateDate: "2026-08-03",
    chapters: [
      { number: 1, title: "第一话 - 午夜钟声", date: "2026-04-10" },
      { number: 2, title: "第二话 - 消失的同学", date: "2026-04-17" },
      { number: 3, title: "第三话 - 地下实验室", date: "2026-04-24" },
      { number: 4, title: "第四话 - 诡异指纹", date: "2026-05-01" },
      { number: 5, title: "第五话 - 老师的秘密", date: "2026-05-08" },
      { number: 6, title: "第六话 - 天台上的黑影", date: "2026-05-15" },
      { number: 7, title: "第七话 - 密室逃脱", date: "2026-05-22" },
      { number: 8, title: "第八话 - 真相浮现", date: "2026-05-29" },
    ],
  },
  {
    id: 5,
    slug: "summer-love-letter",
    title: "夏日的情书",
    author: "尹恩惠",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romantic%20illustration%20of%20young%20couple%20sitting%20under%20cherry%20blossom%20tree%20at%20sunset%2C%20warm%20golden%20light%2C%20soft%20pastel%20colors%2C%20dreamy%20watercolor%20manga%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    description: "高中三年级的夏天，一封匿名情书打破了韩智雅平静的生活。她开始寻找情书的作者，却在过程中发现了三份不同却又同样真挚的感情。这个夏天，青春的悸动如此美好。",
    rating: 9.1,
    views: 1680000,
    status: "已完结",
    tags: ["青春", "恋爱", "校园", "纯爱"],
    updateDate: "2026-06-30",
    chapters: [
      { number: 1, title: "第一话 - 那封信", date: "2026-01-15" },
      { number: 2, title: "第二话 - 三个嫌疑人", date: "2026-01-22" },
      { number: 3, title: "第三话 - 图书馆的秘密", date: "2026-01-29" },
      { number: 4, title: "第四话 - 运动会告白", date: "2026-02-05" },
      { number: 5, title: "第五话 - 雨中的答案", date: "2026-02-12" },
      { number: 6, title: "第六话 - 夏天的约定", date: "2026-02-19" },
    ],
  },
  {
    id: 6,
    slug: "dragon-warrior-chronicles",
    title: "龙战士传说",
    author: "郑泰浩",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20epic%20fantasy%20illustration%20of%20warrior%20holding%20flaming%20sword%20facing%20massive%20dragon%20in%20sky%2C%20dramatic%20clouds%20and%20lightning%2C%20heroic%20atmosphere%2C%20clean%20watercolor%20manga%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    description: "在龙与人类共存的世界中，少年剑客李青云意外与远古龙族签订契约。他踏上了成为最强龙战士的征程，沿途结交伙伴，对抗邪恶势力，揭开世界存亡的秘密。",
    rating: 9.3,
    views: 2100000,
    status: "连载中",
    tags: ["奇幻", "冒险", "龙", "热血"],
    updateDate: "2026-08-05",
    chapters: [
      { number: 1, title: "第一话 - 龙之契约", date: "2026-01-20" },
      { number: 2, title: "第二话 - 初战试炼", date: "2026-01-27" },
      { number: 3, title: "第三话 - 伙伴集结", date: "2026-02-03" },
      { number: 4, title: "第四话 - 暗影来袭", date: "2026-02-10" },
      { number: 5, title: "第五话 - 龙谷秘境", date: "2026-02-17" },
      { number: 6, title: "第六话 - 觉醒之力", date: "2026-02-24" },
      { number: 7, title: "第七话 - 王国危机", date: "2026-03-03" },
      { number: 8, title: "第八话 - 终极之战", date: "2026-03-10" },
    ],
  },
  {
    id: 7,
    slug: "prison-break-girl",
    title: "越狱少女",
    author: "韩素希",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20action%20illustration%20of%20strong%20female%20character%20in%20prison%20uniform%20breaking%20chains%2C%20intense%20expression%2C%20dramatic%20lighting%20from%20above%2C%20clean%20watercolor%20manga%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    description: "天才少女黑客林素妍被冤枉入狱后，凭借超凡智慧策划了一场惊天越狱。在逃亡过程中，她不仅要躲避追捕，还要找出陷害她的真正幕后黑手。一场智力和勇气的较量就此展开。",
    rating: 8.9,
    views: 1320000,
    status: "连载中",
    tags: ["动作", "悬疑", "越狱", "女性主角"],
    updateDate: "2026-08-02",
    chapters: [
      { number: 1, title: "第一话 - 冤罪", date: "2026-03-01" },
      { number: 2, title: "第二话 - 监狱法则", date: "2026-03-08" },
      { number: 3, title: "第三话 - 越狱计划", date: "2026-03-15" },
      { number: 4, title: "第四话 - 地下通道", date: "2026-03-22" },
      { number: 5, title: "第五话 - 自由之日", date: "2026-03-29" },
      { number: 6, title: "第六话 - 追捕开始", date: "2026-04-05" },
      { number: 7, title: "第七话 - 黑客对决", date: "2026-04-12" },
    ],
  },
  {
    id: 8,
    slug: "my-boss-is-a-cat",
    title: "我的老板是只猫",
    author: "宋多惠",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cute%20comedy%20illustration%20of%20fluffy%20orange%20cat%20wearing%20tiny%20business%20suit%20sitting%20on%20office%20desk%2C%20funny%20expression%2C%20bright%20colorful%20watercolor%20manga%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    description: "职场菜鸟金多美发现自己的直属上司竟然是一只会说人话的猫！这只猫上司不仅毒舌苛刻，还经常用猫的方式管理团队——在键盘上踩来踩去、午睡时间比工作时间长。爆笑职场喜剧，治愈你的工作压力！",
    rating: 9.4,
    views: 3200000,
    status: "连载中",
    tags: ["搞笑", "职场", "猫", "治愈"],
    updateDate: "2026-08-05",
    chapters: [
      { number: 1, title: "第一话 - 猫上司登场", date: "2026-04-20" },
      { number: 2, title: "第二话 - 猫式KPI", date: "2026-04-27" },
      { number: 3, title: "第三话 - 午睡会议", date: "2026-05-04" },
      { number: 4, title: "第四话 - 猫粮福利", date: "2026-05-11" },
      { number: 5, title: "第五话 - 客户来访", date: "2026-05-18" },
      { number: 6, title: "第六话 - 公司团建", date: "2026-05-25" },
      { number: 7, title: "第七话 - 猫的告白", date: "2026-06-01" },
      { number: 8, title: "第八话 - 年度总结", date: "2026-06-08" },
    ],
  },
  {
    id: 9,
    slug: "blood-moon-academy",
    title: "血月学院",
    author: "姜美娜",
    category: "horror",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20horror%20illustration%20of%20gothic%20school%20building%20under%20red%20moon%2C%20silhouette%20of%20students%20in%20uniforms%2C%20crows%20flying%2C%20dark%20eerie%20atmosphere%2C%20vintage%20watercolor%20manga%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    description: "血月学院是一所只在夜晚开课的学校。新生尹河琳入学后发现，这所学院的学生和老师都隐藏着不为人知的黑暗秘密。每个满月之夜，都会有人永远消失。而她，可能是下一个。",
    rating: 8.7,
    views: 1150000,
    status: "连载中",
    tags: ["恐怖", "校园", "吸血鬼", "暗黑"],
    updateDate: "2026-08-01",
    chapters: [
      { number: 1, title: "第一话 - 入学通知", date: "2026-03-20" },
      { number: 2, title: "第二话 - 血月升起", date: "2026-03-27" },
      { number: 3, title: "第三话 - 第一个牺牲者", date: "2026-04-03" },
      { number: 4, title: "第四话 - 地下室", date: "2026-04-10" },
      { number: 5, title: "第五话 - 学长警告", date: "2026-04-17" },
      { number: 6, title: "第六话 - 满月逃亡", date: "2026-04-24" },
    ],
  },
  {
    id: 10,
    slug: "twins-destiny",
    title: "双生花",
    author: "林秀晶",
    category: "drama",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20drama%20illustration%20of%20twin%20girls%20facing%20each%20other%20with%20mirror%20reflection%2C%20one%20in%20white%20dress%20one%20in%20black%20dress%2C%20emotional%20atmosphere%2C%20soft%20watercolor%20manga%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    description: "一对双胞胎姐妹在出生时被不同家庭收养。十八年后，富家千金与贫民少女在校园重逢。她们不仅长相一模一样，还爱上了同一个男生。命运的交织让这对失散姐妹陷入了爱情与亲情的双重漩涡。",
    rating: 9.0,
    views: 1450000,
    status: "连载中",
    tags: ["剧情", "双胞胎", "家庭", "爱情"],
    updateDate: "2026-08-04",
    chapters: [
      { number: 1, title: "第一话 - 命运的重逢", date: "2026-04-01" },
      { number: 2, title: "第二话 - 另一个我", date: "2026-04-08" },
      { number: 3, title: "第三话 - 同一个心跳", date: "2026-04-15" },
      { number: 4, title: "第四话 - 秘密揭晓", date: "2026-04-22" },
      { number: 5, title: "第五话 - 选择的岔路", date: "2026-04-29" },
      { number: 6, title: "第六话 - 姐妹之间", date: "2026-05-06" },
    ],
  },
  {
    id: 11,
    slug: "blossom-in-winter",
    title: "冬季绽放",
    author: "郑彩妍",
    category: "bl",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romantic%20BL%20illustration%20of%20two%20handsome%20young%20men%20standing%20close%20in%20snowy%20winter%20street%2C%20scarves%20and%20coats%2C%20warm%20tender%20atmosphere%2C%20soft%20watercolor%20manga%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    description: "钢琴天才李在勋在首尔的冬天遇到了街头画家朴智旻。音乐与美术的碰撞，两个灵魂在寒冷中互相取暖。但家庭的压力和社会的偏见，让他们的爱情之路充满了荆棘与泪水的考验。",
    rating: 9.6,
    views: 2800000,
    status: "连载中",
    tags: ["BL", "音乐", "美术", "治愈"],
    updateDate: "2026-08-05",
    chapters: [
      { number: 1, title: "第一话 - 初雪之遇", date: "2026-02-14" },
      { number: 2, title: "第二话 - 钢琴与画笔", date: "2026-02-21" },
      { number: 3, title: "第三话 - 深夜便利店", date: "2026-02-28" },
      { number: 4, title: "第四话 - 第一次约会", date: "2026-03-07" },
      { number: 5, title: "第五话 - 暴风雨来临", date: "2026-03-14" },
      { number: 6, title: "第六话 - 分离与重逢", date: "2026-03-21" },
      { number: 7, title: "第七话 - 为你弹奏", date: "2026-03-28" },
      { number: 8, title: "第八话 - 永恒乐章", date: "2026-04-04" },
    ],
  },
  {
    id: 12,
    slug: "goddess-of-war",
    title: "战争女神",
    author: "孙艺珍",
    category: "gl",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20GL%20illustration%20of%20two%20beautiful%20female%20warriors%20in%20armor%20holding%20swords%20back%20to%20back%2C%20battlefield%20glow%2C%20strong%20and%20elegant%2C%20watercolor%20manga%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    description: "在古代战场上，女将军韩月英与敌国女将军柳如烟在无数次交锋中，从敌人变成了惺惺相惜的知己。当两国爆发全面战争，她们必须在忠诚与爱情之间做出艰难的选择。",
    rating: 9.1,
    views: 1580000,
    status: "已完结",
    tags: ["GL", "战争", "古风", "强强"],
    updateDate: "2026-07-15",
    chapters: [
      { number: 1, title: "第一话 - 沙场初遇", date: "2025-12-01" },
      { number: 2, title: "第二话 - 棋逢对手", date: "2025-12-08" },
      { number: 3, title: "第三话 - 山谷秘会", date: "2025-12-15" },
      { number: 4, title: "第四话 - 并肩作战", date: "2025-12-22" },
      { number: 5, title: "第五话 - 背叛与信任", date: "2025-12-29" },
      { number: 6, title: "第六话 - 最后一战", date: "2026-01-05" },
      { number: 7, title: "第七话 - 和平之约", date: "2026-01-12" },
    ],
  },
];